import React from "react";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { useSearchModalContext } from "contexts/SearchModalContext";

import { FaIcon } from "components/FaIcon/FaIcon";
import { KeyboardShortcut } from "components/KeyboardShortcut/KeyboardShortcut";

import { getOperatingSystem, OperatingSystem } from "utils/operating-system";

import "./SearchBar.scss";

export function SearchBar() {
    const [os, setOs] = React.useState<Nullable<OperatingSystem>>(null);
    const { dispatch } = useSearchModalContext();

    React.useEffect(() => {
        setOs(getOperatingSystem());
    }, []);

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        dispatch({ type: "set_search_modal_open", value: true });
    };

    let shortcut;
    if (os) {
        let specialChar = "ctrl";
        let classes;

        if (os === "mac") {
            specialChar = "⌘";
            classes = "symbol";
        }

        shortcut = (
            <div className="shortcut-container">
                <KeyboardShortcut className={classes}>
                    {specialChar}
                </KeyboardShortcut>
                <KeyboardShortcut>k</KeyboardShortcut>
            </div>
        );
    }

    return (
        <button className="search-bar-button" onClick={handleButtonClick}>
            <FaIcon icon={faSearch} className="search-icon" />
            <div className="search-placeholder">Search</div>
            {shortcut}
        </button>
    );
}
